import { type ClinicianRTMCode, clinicianRTMCodes, educationRTMCodes, patientRtmCodes, type RTMCode, type RTMFamily } from '@/types/RTM';

export const DEFAULT_RTM_UNIT_COUNT = 2;

export const clinicianCodeThresholds: Record<ClinicianRTMCode, number> = {
  98979: 10,
  98980: 20,
  98981: 20,
};

export const codeLabels: Record<ClinicianRTMCode, string> = {
  '98979': '98979',
  '98980': '98980',
  '98981': '98981',
};

export const rtmFamilyCodes: Record<RTMFamily, readonly RTMCode[]> = {
  education: educationRTMCodes,
  patientActivity: patientRtmCodes,
  clinicianMonitoring: clinicianRTMCodes,
};
